import { hiDPI, size } from "polished";
import styled, { css } from "styled-components";
import FantasyLogo from "../../img/fantasy-logo.svg?react";
import playerComposite1x from "../../img/player-composite-@1x.png";
import playerComposite2x from "../../img/player-composite-@2x.png";
import ClientLogo from "../../img/spl-logo.svg?react";

const stickyHeaderStyles = css`
  position: sticky;
  top: 0;
  z-index: 3;
  background-color: ${({ theme }) => theme.colors.primary};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: box-shadow 0.3s ease;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    position: static;
    box-shadow: none;
  }
`;

export const GameHeaderWrapper = styled.header`
  padding: ${({ theme }) => theme.space[0]};
  background: ${({ theme }) => theme.colors.primary};

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    display: block;
    background: transparent;
  }
`;

export const StickyNavigationWrap = styled.div`
  ${stickyHeaderStyles}
  top: ${({ theme }) => theme.space[2]};
  isolation: isolate;

  &::before {
    content: "";
    position: absolute;
    top: ${({ theme }) => `-${theme.space[2]}`};
    inset-inline-start: 0;
    width: 100%;
    height: ${({ theme }) => theme.space[2]};
    pointer-events: none;
    background: ${({ theme }) => theme.colors.primary};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    &::before {
      content: none;
    }
  }
`;

export const GameHeaderOuter = styled.div`
  display: flex;
  justify-content: center;
`;

export const GameHeaderInner = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 100%;
  max-width: 1220px;
  height: 110px;
  padding: 0 ${({ theme }) => theme.space[2]};

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    height: 130px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    height: 180px;
  }
`;

export const PlayerImage = styled.div`
  position: absolute;
  bottom: 0;
  inset-inline-end: 0;
  width: 100%;
  height: 86%;
  background-image: url(${playerComposite1x});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 100% 0;
  [dir="rtl"] & {
    background-position: 0 100%;
  }
  z-index: 4;
  pointer-events: none;

  ${hiDPI(2)} {
    background-image: url(${playerComposite2x});
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    inset-inline-end: 0;
    height: 96%;
  }
`;

export const HeaderLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  z-index: 1;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    gap: ${({ theme }) => theme.space[4]};
    margin: ${({ theme }) => `${theme.space[3]} 0`};
  }
`;

const ClientLogoStyles = css`
  ${size(54, "auto")}

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    ${size(78, "auto")}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    ${size(102, "auto")}
  }
  vertical-align: middle;
`;

export const StyledClientLogo = styled(ClientLogo)`
  ${ClientLogoStyles}
`;

const FantasyLogoStyles = css`
  ${size(18, "auto")}

  @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
    ${size(23, "auto")}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    ${size(38, "auto")}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    ${size(50, "auto")}
  }
  vertical-align: middle;
`;

export const GameTitle = styled.h1`
  margin: 0;
`;

export const StyledFantasyLogo = styled(FantasyLogo)`
  ${FantasyLogoStyles}
  margin: 0;
  direction: ltr;
`;

export const TitleSponsorWrap = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WebViewWrapper = styled.header`
  ${stickyHeaderStyles}
  box-sizing: border-box;
  width: 100%;
  margin: 0;

  nav {
    margin-top: ${({ theme }) => theme.space[2]};
  }

  nav ul {
    justify-content: flex-start;
  }
`;
